import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <>
      <Seo
        title="About Us | Juwai Morning Teer"
        description="Learn who runs Juwai Morning Teer and our mission of providing accurate, manually verified informational content around teer results."
        path="/about"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "About Us", path: "/about" },
        ]}
      />
      <PageShell>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-emerald-950">
          About Us
        </h1>
        <div className="prose prose-sm sm:prose-base max-w-none mt-4 text-slate-700 leading-relaxed">
          <p>
            Juwai Morning Teer is an independent informational website. Our goal
            is to publish clean, human-verified teer result information for
            reference purposes only.
          </p>
          <p>
            Every number visible on this website is added manually by our small
            editorial team through a private admin panel. Nothing on this site
            is generated automatically or algorithmically predicted.
          </p>
          <p>
            We do not run the underlying activity, we do not sell tickets, we do
            not accept payments, and we do not facilitate any form of betting
            or gambling. Please read our{" "}
            <a href="/disclaimer" className="text-emerald-800 underline">disclaimer</a>{" "}
            for full details.
          </p>
        </div>
      </PageShell>
    </>
  );
}
